export const state = {
  careerInfoEntryData: {
    name: '',
    nameKana: '',
    birthDateYear: '',
    birthDateMonth: '',
    birthDateDay: '',
    sexFlg: '',
    prefId: '',
    telCellular: '',
    email: '',
    science: '',
    schlcrKbn: '',
    schlName: '',
    schlDeptName: '',
    gradyr: ''
  },
  measureData: {
    revisionNo: ''
  }
}

export const mutations = {
  updateEntryData (state, { name, nameKana, birthDateYear, birthDateMonth, birthDateDay, sexFlg, prefId, telCellular, email, science, schlcrKbn, schlName, schlDeptName, gradyr }) {
    if (typeof name !== 'undefined') {
      state.careerInfoEntryData.name = name
    }
    if (typeof nameKana !== 'undefined') {
      state.careerInfoEntryData.nameKana = nameKana
    }
    if (typeof birthDateYear !== 'undefined') {
      state.careerInfoEntryData.birthDateYear = birthDateYear
    }
    if (typeof birthDateMonth !== 'undefined') {
      state.careerInfoEntryData.birthDateMonth = birthDateMonth
    }
    if (typeof birthDateDay !== 'undefined') {
      state.careerInfoEntryData.birthDateDay = birthDateDay
    }
    if (typeof sexFlg !== 'undefined') {
      state.careerInfoEntryData.sexFlg = sexFlg
    }
    if (typeof prefId !== 'undefined') {
      state.careerInfoEntryData.prefId = prefId
    }
    if (typeof telCellular !== 'undefined') {
      state.careerInfoEntryData.telCellular = telCellular
    }
    if (typeof email !== 'undefined') {
      state.careerInfoEntryData.email = email
    }
    if (typeof science !== 'undefined') {
      state.careerInfoEntryData.science = science
    }
    if (typeof schlcrKbn !== 'undefined') {
      state.careerInfoEntryData.schlcrKbn = schlcrKbn
    }
    if (typeof schlName !== 'undefined') {
      state.careerInfoEntryData.schlName = schlName
    }
    if (typeof schlDeptName !== 'undefined') {
      state.careerInfoEntryData.schlDeptName = schlDeptName
    }
    if (typeof gradyr !== 'undefined') {
      state.careerInfoEntryData.gradyr = gradyr
    }
  },
  updateMeasureData (state, { revisionNo }) {
    if (typeof revisionNo !== 'undefined') {
      state.measureData.revisionNo = revisionNo
    }
  }
}

export const actions = {
  storeEntryData (context, { name, nameKana, birthDateYear, birthDateMonth, birthDateDay, sexFlg, prefId, telCellular, email, science, schlcrKbn, schlName, schlDeptName, gradyr }) {
    context.commit(
      'updateEntryData',
      {
        name: name,
        nameKana: nameKana,
        birthDateYear: birthDateYear,
        birthDateMonth: birthDateMonth,
        birthDateDay: birthDateDay,
        sexFlg: sexFlg,
        prefId: prefId,
        telCellular: telCellular,
        email: email,
        science: science,
        schlcrKbn: schlcrKbn,
        schlName: schlName,
        schlDeptName: schlDeptName,
        gradyr: gradyr
      }
    )
  },
  clearApplicationData (context) {
    context.commit(
      'updateEntryData',
      {
        name: '',
        nameKana: '',
        birthDateYear: '',
        birthDateMonth: '',
        birthDateDay: '',
        sexFlg: '',
        prefId: '',
        telCellular: '',
        email: '',
        science: '',
        schlcrKbn: '',
        schlName: '',
        schlDeptName: '',
        gradyr: ''
      }
    )
  },
  storeMeasureData (context, { revisionNo }) {
    context.commit(
      'updateMeasureData',
      {
        revisionNo: revisionNo
      }
    )
  },
  clearMeasureData (context) {
    context.commit(
      'updateMeasureData',
      {
        revisionNo: ''
      }
    )
  }
}

export const getters = {
  getEntryData (state) {
    return state.careerInfoEntryData
  },
  getMeasureData (state) {
    return state.measureData
  }
}
